export type QueryPrimitive = string | number | boolean | null | undefined | Date
export type QueryValue = QueryPrimitive | readonly QueryPrimitive[]
export type QueryParameters = Readonly<Record<string, QueryValue>>

function serializeValue(value: Exclude<QueryPrimitive, null | undefined>) {
  return value instanceof Date ? value.toISOString() : String(value)
}

export function serializeQuery(parameters?: QueryParameters) {
  if (!parameters) return ''
  const search = new URLSearchParams()
  for (const [key, rawValue] of Object.entries(parameters)) {
    const values = Array.isArray(rawValue) ? rawValue : [rawValue]
    for (const value of values) {
      if (value !== null && value !== undefined) search.append(key, serializeValue(value))
    }
  }
  const value = search.toString()
  return value ? `?${value}` : ''
}

export function buildApiUrl(baseUrl: string, path: string, query?: QueryParameters) {
  const base = baseUrl.replace(/\/+$/, '')
  const resource = path.replace(/^\/+/, '')
  return `${base}/${resource}${serializeQuery(query)}`
}
